import api from 'app/api';
import getAll from './get-promotions';
import add from './add-promotion';
import get from './get-promotion';
import edit from './edit-promotion';

export const nestedProductCategoriesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getPromotions: getAll(builder),
        addPromotion: add(builder),
        getPromotion: get(builder),
        editPromotion: edit(builder),
    }),
});

export const { useGetPromotionsQuery, useAddPromotionMutation, useGetPromotionQuery, useEditPromotionMutation } =
    nestedProductCategoriesApi;
